import React from "react";
import "../styles/Vision.css";
import vision from "./images/vision-eye-icon.png";
function Vision() {
  return (
    <>
      <div id="vision">
        <div className="vision-img">
          <img src={vision} alt="vision logo" />
          <h1>VISION</h1>
        </div>
        <p className="vision-desc">
          We envision itself as a dynamic and versatile company that provides
          comprehensive solutions in construction and IT domains. In the
          construction sector, we aim to revolutionize the industry with
          innovative and sustainable building practices, ensuring quality,
          efficiency, and safety in every project. By leveraging advanced
          technologies and expert craftsmanship, the company aspires to address
          complex construction challenges and deliver exceptional results that
          exceed client expectations. Simultaneously, We are committed to
          offering cutting-edge IT solutions. The
          company aims to empower businesses with robust, scalable, and secure
          technology solutions that enhance operational efficiency and drive
          digital transformation. By integrating expertise from both fields,
          Trouble Fixer strives to be a trusted partner for clients, delivering
          tailored solutions that address their unique needs and ensure
          long-term success.
        </p>
      </div>
    </>
  );
}

export default Vision;
